import { Component, Input } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  FilterOperator,
} from '@progress/kendo-data-query';
import { BaseCustomFilterComponent } from './base-custom-filter.component';

@Component({ standalone: false, 
  selector: 'date-range-filter',
  styles: [
    `
      kendo-daterange > kendo-dateinput.range-filter {
        display: inline-block;
      }
      .k-button {
        margin-left: 5px;
      }
    `,
  ],
  template: `
    <kendo-daterange>
      <kendo-dateinput
        class="range-filter"
        kendoDateRangeStartInput
        [value]="start"
        (valueChange)="filterRange($event, end)"
        style="width:80px"
      >
      </kendo-dateinput>
      -
      <kendo-dateinput
        class="range-filter"
        kendoDateRangeEndInput
        [value]="end"
        (valueChange)="filterRange(start, $event)"
        style="width:80px"
      >
      </kendo-dateinput>
    </kendo-daterange>
    <button
      *ngIf="hasFilter"
      kendoButton
      icon="clear"
      title="Clear"
      (click)="clearFilter()"
    ></button>
  `,
})
export class DateRangeFilterComponent extends BaseCustomFilterComponent {
  @Input() public filter: CompositeFilterDescriptor;

  @Input()
  public field: string;

  // Constructor needed for proper filter functioning
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(filterService: FilterService) {
    super(filterService);
  }

  public resetDefault(): void {
    this.clearFilter();
  }

  public get start(): Date {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field, operator }) => {
          return (
            field === this.field &&
            operator === FilterOperator.GreaterThanOrEqual
          );
        },
      );
      if (filter && filter.value) {
        return new Date(filter.value);
      }
    }
    return null;
  }

  public get end(): Date {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field, operator }) => {
          return (
            field === this.field && operator === FilterOperator.LessThanOrEqual
          );
        },
      );
      if (filter && filter.value) {
        return new Date(filter.value);
      }
    }
    return null;
  }

  public get hasFilter(): boolean {
    return this.filtersByField(this.field).length > 0;
  }

  public clearFilter(): void {
    this.filterService.filter(this.removeFilter(this.field));
  }

  public addFilter(filter: FilterDescriptor): void {
    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    root.filters.push({
      field: filter.field,
      operator: filter.operator,
      value: new Date(filter.value),
    });
    this.filterService.filter(root);
  }

  public filterRange(start: Date, end: Date): void {
    this.filter = this.removeFilter(this.field);

    const filters: FilterDescriptor[] = [];

    if (start) {
      filters.push({
        field: this.field,
        operator: FilterOperator.GreaterThanOrEqual,
        value: start,
      });
    }

    if (end) {
      filters.push({
        field: this.field,
        operator: FilterOperator.LessThanOrEqual,
        value: end,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }

    this.filterService.filter(root);
  }
}
